import React from 'react'
import Slider from './Slider'

const Hero = (props) => {
return <div >
    <Slider />
</div>
}

export default Hero